import { ATableHeader } from '../components/organisms/ATable';

export const exportToExcel = (headers: ATableHeader[], rows: any[], exportFileName: string = 'table-data.csv') => {
    const validHeaders = headers.filter((h) => h.field);
    const csvHeader = validHeaders.map((h) => h.title).join(';');
    const csvRows = rows.map((row) =>
        validHeaders
            .map((h) => {
                const keys = h.field!.split('.');
                let value: any = row;
                keys.forEach((k) => {
                    value = value ? value[k] : '';
                });
                if (value === undefined || value === null) value = '';

                if (Array.isArray(value)) {
                    const isPrimitive = value.every((v) => ['string', 'number', 'boolean'].includes(typeof v));
                    value = isPrimitive ? value.join(', ') : JSON.stringify(value);
                } else if (typeof value === 'object') {
                    value = JSON.stringify(value);
                }

                return `"${String(value).replace(/"/g, '""')}"`;
            })
            .join(';')
    );
    const csvContent = [csvHeader, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    if (!exportFileName.toLowerCase().endsWith('.csv')) {
        exportFileName += '.csv';
    }
    link.setAttribute('download', exportFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
